<div class="animated fadeInRight">
    <!-- MENU DE TITULOS -->
    <app-lfsa-card-v2
      [titulo]      = "DAT_TITULOS.titulo"
      [modulo]      = "GLOBAL_TITULOS.modulo"
      [tituloCard]  = "DAT_TITULOS.tituloCardList"
      [innTemplate] = "enviarTemplateEdit"
      [innTemplateButton]="innTemplateButton">
    </app-lfsa-card-v2>
    <!-- MENU DE TITULOS -->
  
    <!-- OPCIONES BOTONES IZQUIERDO -->
    <ng-template #innTemplateButton>
      <div class="col-md-6 mb-2">
        <div class="pagetitle">
          <div class="btn-group-justified btn-group" style="float: right;">
            <button (click)="nuevo()" class="btn btn-primary"> <i aria-hidden="true" class="fa fa-plus"></i> Agregar </button>
          </div>
        </div>
      </div>
    </ng-template>
    <!-- OPCIONES BOTONES IZQUIERDO -->
  
    <!-- GRILLA -->
    <ng-template #enviarTemplateEdit>
      <div class="form-group col-md-12">
        <input class="form-control mb-4" placeholder="Buscar.. " [(ngModel)]="textoBuscar " id="quickFilter " (keyup)="onQuickFilterChanged() "  #quickFilter />

        <app-lfsa-loading-v2 *ngIf="loading"></app-lfsa-loading-v2>

        <ag-grid-angular #agGrid (gridReady)="onGridReady($event)"  
                        [id]      ="DAT_AG_GRID.id" 
                        [class]   ="DAT_AG_GRID.class" 
                        [ngStyle] ="DAT_AG_GRID.style" 
                        [rowData] ="rowData" 
                        [sideBar] ="true"
                        [columnDefs]="columnDefs"
                        [defaultColDef]="defaultColDef"
                        
                        [pagination]="DAT_AG_GRID.pagination" 
                        [paginationPageSize]="DAT_AG_GRID.pagina"
                        [allowContextMenuWithControlKey]="true"
                        [frameworkComponents]="frameworkComponents" >
        </ag-grid-angular>
      </div>
      <!-- GRILLA [cellSelection]="true" -->
    </ng-template>
  </div>
  
    <!-- MODAL  -->
    <app-lfsa-modal [innTemplate] = "abrirModal" [classModal] = "'modal-dialog modal-lg'" [idButton] = "'abrirModal'" [idClose] = "'cerrarModal'" [titulo] = "titleModal">
    </app-lfsa-modal>

    <ng-template #abrirModal>
        <div class="container-fluid">
            <form [formGroup]="formulario" mat-dialog-content>
                <div class="row">
                    <div class="col form-group">
                        <app-lfsa-input formControlName="id" [label]="'* ID Mensaje'" [id]="'id'" [control]="formulario.get('id')" [type]="'number'" [isReadOnly]="true">
                        </app-lfsa-input>
                    </div>
                    <div class="col form-group">
                        <app-lfsa-combo-box [label]="'* Seleccione Marquesina/ubicación'" formControlName="marquesinaId" [control]="formulario.get('marquesinaId')"
                                            [comboBox]="listMarquesinas" [opcion]="'codigo'" [idOpcion]="'id'" class="form-control-sm">
                        </app-lfsa-combo-box>
                    </div>
                    
                    <div class="col form-group">
                      <label for="">Accion/estado para envio de mensaje</label>
                      <select formControlName="tipo" name="tipo" id="tipo" class="form-control">
                        <option value="REVISION_HABILITADA">REVISION_HABILITADA</option>
                        <option value="REVISION_ACEPTADA">REVISION_ACEPTADA</option>
                        <option value="REVISION_RECHAZADA">REVISION_RECHAZADA</option>
                        <option value="REVISION_CALIDAD_HABILITADA">REVISION_CALIDAD_HABILITADA</option>
                        <option value="REVISION_OPERADOR_HABILITADA">REVISION_OPERADOR_HABILITADA</option>
                        <option value="BALANZA_IN">BALANZA_IN</option>
                        <option value="BALANZA_OUT">BALANZA_OUT</option>
                        <option value="CONVOY_PLANIFICADO">CONVOY_PLANIFICADO</option>
                        <option value="ASIGNAR_SELLOS">ASIGNAR_SELLOS</option>
                      </select>
                    </div>
                </div>

                <div class="row">
                    <div class="col form-group">
                      <label for="">Envia Indicador Semaforo</label>
                      <select formControlName="indicador" name="indicador" id="indicador" class="form-control">
                        <option value="0">NO APLICA</option>
                        <option value="1">ENTRADA</option>
                        <option value="2">SALIDA</option>
                      </select>
                    </div>
                    <div class="col form-group">
                        <app-lfsa-input formControlName="mensaje" [label]="'* Mensajes separado por (,). Cada separación corresponde a una línea'" 
                        [id]="'mensaje'" [control]="formulario.get('mensaje')" [type]="'text'">
                        </app-lfsa-input>
                    </div>
                </div>

                <app-lfsa-botones-formulario 
                    (devolverAccion)    = "acciones( $event )" 
                    [formularioValido]  = "formulario.invalid" 
                    [loading] ="loading" [textBoton] ="'Guardar'" class ="row mt-3">
                </app-lfsa-botones-formulario>
            </form>
        </div>
    </ng-template>
    <!-- END MODAL --> 